"use client";
import { Link } from "@/app/components/lib/navigation/Link";
import { Fragment } from "react";
import { Col, Row } from "@/utils/bootstrap";
import SvgCrumbSubPath from "./crumb-svgs/SvgCrumbSubPath";
import SvgCrumbBack from "./crumb-svgs/SvgCrumbBack";
import { useRouter } from "../navigation/useRouter";
import { useTranslation } from "@/hooks/localization/useTranslations";
import useIsRtl from "@/hooks/useIsRtl";
// import { truncateString } from "@/utils/functions/functions";

interface Props {
  hierarchy: {
    text: string;
    link?: string;
    onClick?: () => void;
  }[];
  noHome?: boolean;
  hideCrumbBack?: boolean;
  onClickArrow?: () => void;
}

const BreadCrumb: React.FC<Props> = ({
  hierarchy = [],
  noHome = false,
  hideCrumbBack,
  onClickArrow,
}) => {
  const router = useRouter();
  const t = useTranslation();
  const isRTL = useIsRtl();
  return (
    <div>
      <Row className="m-0 d-flex breadcrumb align-items-center">
        {!hideCrumbBack && (
          <Col className="p-0 col-auto d-flex flex-nowrap align-items-center">
            <SvgCrumbBack
              isRTL={isRTL}
              onClick={!!onClickArrow ? onClickArrow : () => router.back()}
            />
          </Col>
        )}
        {!noHome && (
          <Col className="p-0 col-auto d-flex flex-nowrap align-items-center">
            <Link prefetch={false} href={"/"}>
              <div>
                <span className="active">{t?.home}</span>
              </div>
            </Link>
            <SvgCrumbSubPath isRTL={isRTL} />
          </Col>
        )}
        {hierarchy?.map((node, index) => (
          <Fragment key={index}>
            {index < hierarchy?.length - 1 ? (
              <Col className="p-0 col-auto d-flex flex-nowrap align-items-center">
                <span style={{ maxWidth: "100%", overflow: "hidden" }}>
                  <Link
                    prefetch={false}
                    href={node.link as any}
                    onClick={node.onClick}
                  >
                    <div className="active">
                      {(t as Record<string, string>)[node?.text] ?? node?.text}
                    </div>
                  </Link>
                </span>

                <SvgCrumbSubPath isRTL={isRTL} />
              </Col>
            ) : (
              <Col className="p-0 col-auto not-active">{node?.text}</Col>
            )}
          </Fragment>
        ))}
      </Row>
    </div>
  );
};

export default BreadCrumb;
